import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const ViewToggleSection = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  width: 100%;
`;

const ViewToggleButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: var(--cardBackgroundColor);
  border-radius: 8px;
  padding: 4px;
  gap: 4px;
  border: 1px solid var(--lineColor);
`;

const ViewToggleButton = styled.button<{ isActive: boolean }>`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background: ${({ isActive }) =>
    isActive ? 'var(--buttonBackgroundColor)' : 'transparent'};
  color: ${({ isActive }) =>
    isActive ? 'var(--buttonTextColor)' : 'var(--textColor)'};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 60px;
  cursor: var(--hoverCursorURL), pointer;

  &:hover {
    background: ${({ isActive }) =>
    isActive ? 'var(--buttonBackgroundColor)' : 'var(--hoverColor)'};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export interface ViewOption {
  value: string;
  label: string;
  isShow: boolean;
  drawView: React.ReactNode | null;
}

type Props = {
  viewOptions: ViewOption[];
  defaultViewType: ViewOption['value'];
  extraButton?: React.ReactNode;
  customSetViewType?: (view: any) => void;
  style?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
};

function ViewToggleTab({
  viewOptions,
  defaultViewType,
  extraButton,
  customSetViewType,
  style,
  buttonStyle,
}: Props) {
  const [viewType, setViewType] = useState<any>(defaultViewType);

  const handleViewChange = (view: any) => {
    setViewType(view);
    customSetViewType?.(view);
  };

  useEffect(() => {
    setViewType(defaultViewType);
    customSetViewType?.(defaultViewType); // 부모 컴포넌트 상태도 동기화
  }, [defaultViewType, customSetViewType]);

  return (
    <>
      <ViewToggleSection style={{ ...style }}>
        <ViewToggleButtons>
          {viewOptions
            .filter((option) => option.isShow)
            .map((option) => (
              <ViewToggleButton
                key={option.value}
                isActive={viewType === option.value}
                onClick={() => handleViewChange(option.value)}
                style={{ ...buttonStyle }}
              >
                {option.label}
              </ViewToggleButton>
            ))}
          {extraButton}
        </ViewToggleButtons>
      </ViewToggleSection>

      {viewOptions.find((option) => option.value === viewType)?.drawView}
    </>
  );
}

export default ViewToggleTab;
